import type * as React from 'react'
import {
  Bot as ControllerIcon,
  Camera as VisionDataIcon,
  Flame as ConditionIcon,
  FileCode2 as JobIcon,
  Radio as SignalIcon,
  ScanEye as VisionProcessIcon,
  Waypoints as ArmIcon
} from 'lucide-react'
import type { PlantRobotNodeKind } from '@axilon-apps/domains-ontology-ui-state'

type IconComponent = React.ComponentType<{
  size?: number | string
  className?: string
}>

const ICONS_BY_KIND: Record<PlantRobotNodeKind, IconComponent> = {
  RobotController: ControllerIcon,
  RobotArm: ArmIcon,
  RobotJob: JobIcon,
  RobotIOSignal: SignalIcon,
  RobotCondition: ConditionIcon,
  VisionProcess: VisionProcessIcon,
  VisionData: VisionDataIcon
}

export function robotIconFor(kind: PlantRobotNodeKind): IconComponent {
  return ICONS_BY_KIND[kind]
}

const LABELS: Record<PlantRobotNodeKind, string> = {
  RobotController: 'Controller',
  RobotArm: 'Arm',
  RobotJob: 'Job',
  RobotIOSignal: 'I/O Signal',
  RobotCondition: 'Condition',
  VisionProcess: 'Vision process',
  VisionData: 'Vision data'
}

export function robotLabelFor(kind: PlantRobotNodeKind): string {
  return LABELS[kind]
}
